import { render, staticRenderFns } from "./PlayersList.vue?vue&type=template&id=7520b764&"
import script from "./PlayersList.vue?vue&type=script&lang=js&"
export * from "./PlayersList.vue?vue&type=script&lang=js&"
import style0 from "./PlayersList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports